<template>
  <div style="width: 100%; height: 100%">
    <input
      v-if="isShowInput"
      type="file"
      @change="handleFileUpload"
      accept=".xlsx, .xls" />
    <table
      style="
        width: 100%;
        height: 100%;
        border-collapse: collapse;
        border: 1px solid black;
      ">
      <colgroup>
        <col
          v-for="(colWidth, colIndex) in colWidths"
          :key="colIndex"
          :style="{ width: colWidth + 'px' }" />
      </colgroup>
      <tr
        v-for="(row, rowIndex) in tableData"
        :key="rowIndex"
        :style="{ height: rowHeights[rowIndex] + 'px', lineHeight: '22px' }">
        <td
          v-for="(cell, cellIndex) in row"
          :key="cellIndex"
          :colspan="cell.colspan || 1"
          :rowspan="cell.rowspan || 1"
          :style="getCellStyles(cell)">
          <!-- {{ cell.value }} -->
          <!-- <span
            v-if="isImage(cell.value)"
            v-html="getImageHtml(cell.value)"></span> -->
          <span v-html="cell.value"></span>
          <!-- <div style="font-size: 10px; color: gray">
            W: {{ colWidths[cellIndex] }}px, H: {{ rowHeights[rowIndex] }}px,
            size:{{ cell.fontSize }}, align:{{ cell.alignment }}, font:{{
              cell.font
            }}, bold:{{ cell.bold }}, italic:{{ cell.italic }}
          </div> -->
        </td>
      </tr>
    </table>
    <!-- <div style="text-align: center; margin-top: 20px">
      <button @click="printTable">打印</button>
    </div> -->
    <div class="btn-box mr-t-16">
      <el-button type="primary" @click="printTable"> 打印 </el-button>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import {
  expandWorksheetRange,
  normalizeCellsForSheetHtml,
} from '@/utils/xlsxPrintHelpers';
import { previewForm, printForm } from '@/api/applyForList';

export default {
  props: {
    // 是否显示提示
    isShowInput: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
    },
  },
  data() {
    return {
      regisNumberChoose: null,
      registrationNumber: [],
      tableData: [],
      colWidths: [],
      rowHeights: [],
    };
  },
  created() {
    console.log(this.$route.params, '2222------');
    if (localStorage.getItem('regisNumberChoose')) {
      this.regisNumberChoose = JSON.parse(
        localStorage.getItem('regisNumberChoose')
      );
    }
    if (localStorage.getItem('registrationNumber')) {
      this.registrationNumber = JSON.parse(
        localStorage.getItem('registrationNumber')
      );
    }
  },
  watch: {
    registrationNumber: {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.getPreviewForm();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /** 查询模版 */
    getPreviewForm() {
      previewForm({
        registrationNumber: this.regisNumberChoose
          ? this.regisNumberChoose
          : this.registrationNumber[this.registrationNumber.length - 1],
        type: this.type, //1报名表 2准考证 3成绩单
      }).then((res) => {
        // this.fileUrl = URL.createObjectURL(res);
        this.handleFileUpload(res);
      });
    },
    //打印
    consoleForm() {
      printForm({
        registrationNumber: this.regisNumberChoose
          ? this.regisNumberChoose
          : this.registrationNumber[this.registrationNumber.length - 1],
        type: this.type, //1报名表 2准考证 3成绩单
      }).then((res) => {
        //console.log(res, '4445566===='); //  {size:33;type: "application/json"}
        // if (res.code == 200) {
        //   this.$modal.msgSuccess('操作成功');
        // }
      });
    },
    handleFileUpload(event) {
      // const file = event.target.files[0];
      const file = event;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, {
              type: 'array',
              cellStyles: true,
            });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            this.tableData = this.parseSheet(worksheet);
            this.colWidths = this.getColWidths(worksheet);
            this.rowHeights = this.getRowHeights(worksheet);
          } catch (error) {
            console.error('文件解析出错:', error);
            // 可以在这里添加更友好的错误提示，如弹出对话框
          }
        };
        reader.onerror = () => {
          console.error('文件读取出错:', reader.error);
          // 可以在这里添加更友好的错误提示，如弹出对话框
        };
        reader.readAsArrayBuffer(file);
      }
    },
    parseSheet(worksheet) {
      expandWorksheetRange(worksheet);
      normalizeCellsForSheetHtml(worksheet);
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const tableData = [];

      // Initialize a 2D array to hold the cell data
      for (let row = range.s.r; row <= range.e.r; row++) {
        const rowData = [];
        for (let col = range.s.c; col <= range.e.c; col++) {
          rowData.push({
            value: '',
            colspan: 1,
            rowspan: 1,
            alignment: 'left',
            fontSize: '14px',
            font: '',
            bold: false,
            italic: false,
          });
        }
        tableData.push(rowData);
      }

      // Fill in the cell values
      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          const cell = worksheet[cellAddress];
          if (cell) {
            console.log('cell:', cell); // 打印单元格对象，查看样式信息是否存在
            // 处理换行符，将 \n 替换为 <br>
            tableData[row][col].value = cell.v
              ? cell.v.toString().replace(/\n/g, '<br>')
              : '';
            // 处理对齐方式
            tableData[row][col].alignment =
              (cell.s && cell.s.alignment && cell.s.alignment.horizontal) ||
              'left';

            // 从 cell.s 字段提取字体样式信息
            if (cell.s && cell.s.font) {
              tableData[row][col].bold = cell.s.font.bold || false;
              tableData[row][col].italic = cell.s.font.italic || false;
              tableData[row][col].fontSize = cell.s.font.sz
                ? cell.s.font.sz + 'px'
                : '14px';
              tableData[row][col].font = cell.s.font.name || '';
            } else if (cell.r) {
              // 从 cell.r 字段提取字体样式信息
              const rPr = cell.r.match(/<rPr>(.*?)<\/rPr>/);
              if (rPr) {
                const rPrContent = rPr[1];
                tableData[row][col].bold = rPrContent.includes('<b/>');
                tableData[row][col].italic = rPrContent.includes('<i/>');
                const szMatch = rPrContent.match(/<sz val="(\d+)"/);
                tableData[row][col].fontSize = szMatch
                  ? szMatch[1] + 'px'
                  : '14px';
                const fontMatch = rPrContent.match(/<rFont val="([^"]+)"/);
                tableData[row][col].font = fontMatch ? fontMatch[1] : '';
              }
            }

            // 处理单元格的其他属性，如格式、公式等
            if (cell.t) {
              tableData[row][col].type = cell.t; // 单元格类型（如 's' 表示字符串，'n' 表示数字，'b' 表示布尔值等）
            }
            if (cell.f) {
              tableData[row][col].formula = cell.f; // 单元格公式
            }
            if (cell.z) {
              tableData[row][col].format = cell.z; // 单元格格式
            }
          }
        }
      }

      // Process merged cells
      if (worksheet['!merges']) {
        worksheet['!merges'].forEach((merge) => {
          const startRow = merge.s.r;
          const startCol = merge.s.c;
          const endRow = merge.e.r;
          const endCol = merge.e.c;

          const colspan = endCol - startCol + 1;
          const rowspan = endRow - startRow + 1;

          tableData[startRow][startCol].colspan = colspan;
          tableData[startRow][startCol].rowspan = rowspan;

          // Clear the cells that are part of the merge
          for (let row = startRow; row <= endRow; row++) {
            for (let col = startCol; col <= endCol; col++) {
              if (row !== startRow || col !== startCol) {
                tableData[row][col] = null;
              }
            }
          }
        });
      }

      // 合并区子格需从行中移除，与主格 colspan 一致；用空 td 占位会导致列错位（表样管理/预览）
      return tableData.map((row) => row.filter((cell) => cell !== null));
    },
    getColWidths(worksheet) {
      const cols = worksheet['!cols'] || [];
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const colWidths = new Array(range.e.c + 1);

      // 遍历所有列，获取列宽
      for (let i = 0; i <= range.e.c; i++) {
        const col = cols[i];
        if (col && col.wpx) {
          colWidths[i] = col.wpx;
        } else {
          // 如果没有显式设置列宽，使用默认值 100px
          colWidths[i] = 100;
        }
      }

      return colWidths;
    },

    getRowHeights(worksheet) {
      const rows = worksheet['!rows'] || [];
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const rowHeights = new Array(range.e.r + 1);

      // 遍历所有行，获取行高
      for (let i = 0; i <= range.e.r; i++) {
        const row = rows[i];
        if (row && row.hpx) {
          rowHeights[i] = row.hpx;
        } else {
          // 如果没有显式设置行高，使用默认值 20px
          rowHeights[i] = 20;
        }
      }

      return rowHeights;
    },

    printTable() {
      // let printSuccess = false;

      // const mediaQueryList = window.matchMedia('print');

      // mediaQueryList.addListener((mql) => {
      //   if (!mql.matches) {
      //     if (printSuccess) {
      //       console.log('打印已完成');
      //       this.$message.success('打印成功');
      //       this.consoleForm();
      //     } else {
      //       console.log('打印被取消');
      //     }
      //   }
      // });

      // window.addEventListener('beforeprint', () => {
      //   printSuccess = true;
      // });

      // window.addEventListener('afterprint', () => {
      //   if (!mediaQueryList.matches) {
      //     printSuccess = false;
      //   }
      // });

      window.print();
      // setTimeout(() => {
      //   this.consoleForm();
      // }, 5000);
    },
    getCellStyles(cell) {
      return {
        border: '1px solid black',
        paddingTop: '5px',
        paddingBottom: '5px',
        textAlign: cell.alignment || 'left',
        fontSize: cell.fontSize || '14px',
        fontWeight: cell.bold ? 'bold' : 'normal',
        fontStyle: cell.italic ? 'italic' : 'normal',
        fontFamily: cell.font || 'inherit', // 添加字体样式
      };
    },

    // isImage(value) {
    //   return (
    //     typeof value === 'string' &&
    //     value.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i)
    //   );
    // },
    // getImageHtml(value) {
    //   return `<img src="${value}" style="max-width: 100%; height: auto;" />`;
    // },
  },
};
</script>
<style scoped lang="scss">
@media print {
  .btn-box {
    display: none !important;
  }
}
</style>
